var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-gray-100"},[_c('ContentfulGlobalBanner'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('Nuxt',{staticClass:"container mx-auto px-4 py-12"}),_vm._v(" "),_c('Footer',{staticClass:"mt-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }